import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import {
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
} from "../../../Theme";
import { ReactComponent as EditIcon } from "../../../Icons/Edit.svg";
import { reviewstyle } from "../AddCompany";

const ReviewAccount = ({
  administratorDetails,
  companyDetails,
  setaddblocks,
  errText,
  setErrText,
  loading,
  handleSubmit,
}) => {
  return (
    <>
      <Stack gap="20px">
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Company Details</SecondaryTypography>
            </Stack>
            <Button
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
              onClick={() => {
                setaddblocks({
                  Company_Details: true,
                  Administrator_Details: false,
                  Review_Information: false,
                });
              }}
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Name
              </StyledSecondaryTypography>
              <TypographyDefault>
                {companyDetails?.company_name || ""}
              </TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Country</StyledSecondaryTypography>
              <TypographyDefault>
                {companyDetails?.company_country || ""}
              </TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                {" "}
                {companyDetails?.company_email_address || ""}
              </TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contact Number
              </StyledSecondaryTypography>
              <TypographyDefault>
                {" "}
                +{companyDetails?.company_country_code}{" "}
                {companyDetails?.company_contact_number.slice(
                  companyDetails?.company_country_code?.length
                )}
              </TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                {companyDetails?.company_address}
              </TypographyDefault>
            </Grid>
          </Grid>
        </Box>

        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
          sx={{
            backgroundColor: "white",
            border: "1px solid #E5E7EB",
            borderRadius: "0 0 8px 8px ",
          }}
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button
              type="button"
              sx={{ padding: "10px 18px" }}
              variant="Standard"
              onClick={handleSubmit}
            >
              {loading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default ReviewAccount;
